<div class="tooltip"><span class="icon--qa"></span><span class="tooltip__text"><slot></slot></span></div>